export enum DevApiErrorType {
    /** 请求超时 */
    TIMEOUT = 'TIMEOUT',

    /** http code ⾮ 200/300 系列 */
    HTTP_ERROR = 'HTTP_ERROR',

    /**  期望存在数据但接⼝未返回 */
    DATA_NULL = 'DATA_NULL',

    /** 数据与期望格式不符 */
    DATA_MALFORMED = 'DATA_MALFORMED',

    /** 前端接收数据正常, 但处理数据出错 */
    CLIENT_ERROR = 'CLIENT_ERROR',

    /** 其他 */
    OTHER = 'OTHER',
}
